import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  SuperAdminNotificationRecipient,
  SuperAdminNotificationRecipientCreateInput,
  SuperAdminNotificationRecipientUpdateInput,
} from '@models/superAdminNotificationRecipient.model';
import { superAdminNotificationRecipientService } from '@services/superAdminNotificationRecipient';
import { SUPER_ADMIN_NOTIFICATION_RECIPIENTS_QUERY_KEY } from './useSuperAdminNotificationRecipients';

const invalidate = (queryClient: ReturnType<typeof useQueryClient>) =>
  queryClient.invalidateQueries({ queryKey: SUPER_ADMIN_NOTIFICATION_RECIPIENTS_QUERY_KEY });

export const useCreateSuperAdminNotificationRecipient = () => {
  const queryClient = useQueryClient();
  return useMutation<
    SuperAdminNotificationRecipient,
    Error,
    SuperAdminNotificationRecipientCreateInput
  >({
    mutationFn: (input) => superAdminNotificationRecipientService.createRecipient(input),
    onSuccess: () => invalidate(queryClient),
  });
};

export const useUpdateSuperAdminNotificationRecipient = () => {
  const queryClient = useQueryClient();
  return useMutation<
    SuperAdminNotificationRecipient,
    Error,
    SuperAdminNotificationRecipientUpdateInput
  >({
    mutationFn: (input) => superAdminNotificationRecipientService.updateRecipient(input),
    onSuccess: () => invalidate(queryClient),
  });
};

export const useDeleteSuperAdminNotificationRecipient = () => {
  const queryClient = useQueryClient();
  return useMutation<boolean, Error, string>({
    mutationFn: (id) => superAdminNotificationRecipientService.deleteRecipient(id),
    onSuccess: () => invalidate(queryClient),
  });
};
